<template>
    <l-layout :layout="['xs12']">
      <v-card class="pa-3">
        <v-form ref="passForm">
          <v-layout>
            <l-plate-picker label="通行车辆" v-model="form.plate"></l-plate-picker>
          </v-layout>
          <v-layout column v-for="(p,index) in form.payRule" >
            <pay-rule :record="p"></pay-rule>
          </v-layout>
          <v-layout justify-center>
            <v-btn flat color="primary" @click="addPayRule">添加计费规则配置</v-btn>
          </v-layout>
          <v-layout column v-for="(p,i) in form.passRecord" >
            <pass-record :record="p"></pass-record>
          </v-layout>
          <v-layout justify-center>
              <v-btn flat color="primary" @click="addPassRecord">添加通行记录</v-btn>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="getBill()" :loading="loading">计算账单</v-btn>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="goBillDetail()" :loading="loading">查看账单详情</v-btn>
          </v-layout>
        </v-form>
      </v-card>
    </l-layout>
</template>

<script>
import LSelectDatetime from '../../ladmin/components/LSelectDatetime/LSelectDatetime'
import PassRecord from './passRecord'
import PayRule from './payRule'
import LPlatePicker from '../../components/LPlatePicker'
export default {
  name: 'paySimulateTest',
  components: {LPlatePicker, LSelectDatetime, PassRecord,PayRule},
  data () {
    return {
      loading: false,
      form: {
        plate: '',
        parkSelect: [],
        park: '',
        chargingRule: '',
        chargingRuleSelect: [],
        passRecord: [],
        payRule:[],
        controllerSelect: [],
      },
      billId:''
    }
  },
  created () {
    this.init()
    this.addPassRecord()
    this.addPayRule()
  },
  methods: {
    init () {
      let parkList = this.$store.state.parkingLot.parkingLotList
      for (let i = 0; i < parkList.length; i++) {
        this.form.parkSelect.push(parkList[i])
      }
    },
    addPassRecord () {
      let r = {
        park: '',
        chargingRule: '',
        enterController: '',
        enterTime: '',
        outController: '',
        outTime: '',
        controllerSelect: [],
        bill: '',
        loading: false
      }
      this.form.passRecord.push(r)
    },
    addPayRule(){
      let r = {
        park: '',
        chargingRule: '',
        enterController: '',
        enterTime: '',
        outController: '',
        outTime: '',
        controllerSelect: [],
        bill: '',
        loading: false
      }
      this.form.payRule.push(r)
    },
    async searchChargingRule (val) {
      try {
        let {items} = await this.$store.dispatch('charging/getRuleConfigList', {
          pagination: {page: 1, rowsPerPage: 10},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    goBillDetail (p) {
      console.log(this.billId)
      this.$router.push({name: 'billDetailBox', query: {id: this.billId}})
    },
    async getBill () {
      let passLogs = []
      let payRules = []
      for (let i = 0; i < this.form.passRecord.length; i++) {
        let p = this.form.passRecord[i]
        let obj = {
          'passTime': this.$L.time.toTimeStamp(p.enterTime),
          'gateId': p.enterController
        }
        passLogs.push(obj)
      }
      for(let i=0;i<this.form.payRule.length;i++){
        let obj = {
          "parkId":this.form.payRule[i].park.trim(),
          "chargingType": "simple",
          "chargingRuleId": this.form.payRule[i].chargingRule.id.trim(),
          "isOverCharge": false
        }
        payRules.push(obj)
      }
      let params = {
        'plateInfo': {
          'plateNum': this.form.plate,
          'userId': '168103220743244307',
          'usrgrpInfo': {
            'usrgrpId': 'usrgrpId',
            'extend': {}
          }
        },
        "passRules":payRules,
        'passLogs': passLogs
      }
      this.loading = true
      try {
        let res = await this.$store.dispatch('pay/paySimulateTest', params)
        if(res.data.status+'' === '200'){
          this.$L.alert('success',{message:'生成账单成功'})
          this.billId = res.data.data[0].id
        }else{
          this.$L.alert('error',{message:res.data.msg})
        }
      }
      catch (e) {

      }
      finally {
        this.loading = false
      }
    }
  },
  watch: {
    /*    'form.passRecord': {
      handler (val, oldVal) {
        if (this.form.passRecord.length === 0) {
          return
        }
        for (let j = 0; j < this.form.passRecord.length; j++) {
          let r = this.form.passRecord[j]
          r.controllerSelect = []
          let controllerList = this.$store.state.parkingLot.controllerList
          for (let i = 0; i < controllerList.length; i++) {
            if (controllerList[i].parkingLot.id === r.park) {
              r.controllerSelect.push(controllerList[i])
            }
          }
        }
      },
      deep: true
    } */
  }
}
</script>

<style scoped>

</style>
